'use client';

import { useEffect } from 'react';

export default function ViewCountTracker({ entryId }: { entryId: string }) {
  useEffect(() => {
    const storageKey = `entry-viewed-${entryId}`;
    const lastViewed = localStorage.getItem(storageKey);
    if (!lastViewed) {
      fetch(`/api/entries/${entryId}/view`, { method: 'POST' }).catch(() => {});
      localStorage.setItem(storageKey, new Date().toISOString());
    }
  }, [entryId]);

  return null;
}
